import api from './api';

export const getAllAchievements = () => api.get('/achievements');
export const getMyAchievements = () => api.get('/my-achievements');
export const getLeaderboard = (period = 'all') => api.get(`/leaderboard?period=${period}`);
export const getMyXpHistory = (page = 1) => api.get(`/my-xp-history?page=${page}`);